const RoleTypes = [
  { value: 'all', label: 'All' },
  { value: 'admin-panel-access', label: 'Admin Panel Access' },
  { value: 'adminTools', label: 'Admin Tools' },
  { value: 'biller', label: 'Biller' },
  { value: 'doctor', label: 'Physician' },
  { value: 'nursePractitioner', label: 'Nurse Practitioner' },
  { value: 'physicianAssistant', label: 'Physician Assistant' },
  { value: 'medicalAssistant', label: 'Medical Assistant' },
  { value: 'QHCP', label: 'QHCP' },
  { value: 'support', label: 'Support' },
  { value: 'call-agent', label: 'Call Agent' },
  { value: 'onboarding', label: 'Onboarding' },
  { value: 'registeredNurse', label: 'Registered Nurse' },
  { value: 'patientAcceptance', label: 'Patient Acceptance' },
  { value: 'criticalAlerting', label: 'Critical Alerting' },
  { value: 'atRiskAlerting', label: 'At Risk Alerting' },
  {
    value: 'clientSuccessOnboarding',
    label: 'Client Success Onboarding',
  },
  {
    value: 'clientSuccessScaling',
    label: 'Client Success Scaling',
  },
  { value: 'salesRepresentative', label: 'Sales Representative' },
  { value: 'nutritionist', label: 'Nutritionist' },
  { value: 'callDashboard', label: 'Call Dashboard' },
  { value: 'smsDashboard', label: 'SMS Dashboard' },
  { value: 'smsDashboardUnregistered', label: 'SMS Dashboard Unregistered' },
  { value: 'billingTools', label: 'Billing Tools' },
  { value: 'supervisor', label: 'Supervisor' },
];

export default RoleTypes;
